"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M6.92598 8.38086C3.65315 8.38086 1 11.034 1 14.3068H12.852C12.852 11.034 10.1988 8.38086 6.92598 8.38086Z",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M13 14.5C14.17 13.33 15.3565 11.7916 18.7793 8.32998C18.7665 6.83031 18.1881 5.33455 17.0438 4.1903C14.7296 1.87606 10.9775 1.87606 8.66321 4.1903L2.48729 10.3882",
      stroke: "currentColor",
      strokeWidth: "1.2"
    })]
  });
};

exports.default = Icon;